module.exports = __webpack_public_path__ + "8875c78e3074f2d7506496d8599d401d.png";